export default __webpack_public_path__ + "static/bg-spacex-8e4e124c2f6e597e0e0c9b9a17a727dc.webp";